export const GotoMyPc = '.gotomypc.com';
